import React, { Dispatch } from 'react';
import AlertModalDialog from '../AlertModalDialog';
import { useTranslation } from 'react-i18next';
import {
    showWebDAVDecisionDialog,
} from '../../../../redux/project/file/sliceProjectFileOpen';
import { useDispatch, useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../redux/store';

export interface IWebDavDecisionDialogConfig {
    /** Can be "WEBDAV_VIEW", "WEBDAV_LOCKED|{name}" or "WEBDAV_DECIDE". */
    mode: string;

    /** The URL to force a new WebDAV session. */
    callbackURL: string;
}

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'webDAVDecisionDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const { mode: modeInfo, callbackURL } = useSelector(
        (store: IAppReduxStore) => store.projectFileOpen.webDAVDecisionDialog,
    );

    const [mode, lockHolder] = modeInfo.split('|');

    const callbackOpenWebDAV = () => {
        window.open(callbackURL);
        callbackClose();
    };

    const callbackClose = () => {
        dispatch(showWebDAVDecisionDialog(null));
    };

    const mapping = {
        WEBDAV_VIEW: {
            title: t('WEBDAV_VIEW.title'),
            info: t('WEBDAV_VIEW.info'),
            primaryOption: {
                label: t('WEBDAV_VIEW.primaryOption'),
                callback: callbackOpenWebDAV,
            },
        },
        WEBDAV_DECIDE: {
            title: t('WEBDAV_DECIDE.title'),
            info: t('WEBDAV_DECIDE.info'),
            primaryOption: {
                label: t('WEBDAV_DECIDE.primaryOption'),
                callback: callbackClose,
            },
            secondaryOption: {
                label: t('WEBDAV_DECIDE.secondaryOption'),
                callback: callbackOpenWebDAV,
            },
        },
        WEBDAV_LOCKED: {
            title: t('WEBDAV_LOCKED.title'),
            info: t('WEBDAV_LOCKED.info', { name: lockHolder }),
            primaryOption: {
                label: t('WEBDAV_VIEW.primaryOption'),
                callback: callbackClose,
            },
        },
    };

    return (
        <AlertModalDialog
            isOpen={true}
            dialogTitle={mapping[mode].title}
            dialogBody={mapping[mode].info}
            confirmText={mapping[mode].primaryOption.label}
            cancelText={mapping[mode].secondaryOption?.label}
            onConfirm={mapping[mode].primaryOption.callback}
            onCancel={mapping[mode].secondaryOption?.callback}
            onClose={callbackClose}
            isActionDisabled={false}
        />
    );
};
